import Image from "next/image";
import Link from "next/link";

import { Icona } from "@/components/home/Icona";
import { DATI_MONO, ETICHETTA_ACCESA, TITOLO_LINK } from "@/components/home/stile";
import type { EditorialeRiquadro } from "@/lib/editoriale-settimana";

/** «L'editoriale della settimana» (`.r-ed` dei modelli di /rullo e
 *  /report): la foto in bianco e nero che prende l'altezza libera della
 *  colonna, l'etichetta rame, il titolo serif in corsivo, il sommario e la
 *  firma. I dati arrivano già pronti da lib/editoriale-settimana.ts.
 *
 *  `nudo`: senza bordo né fondo suoi, per chi lo mette dentro un pannello
 *  che li ha già (il pannello a due colonne di /report).
 *
 *  `colonna`: la scheda nella colonna destra da 380 pixel della pagina di
 *  un Paese (`.tr-ed` del modello uploads/turchia.html): foto a rapporto
 *  fisso 16:8 invece che elastica, titolo 28 e sommario 16. */
export function EditorialeSettimana({
  e,
  nudo = false,
  colonna = false,
}: {
  e: EditorialeRiquadro;
  nudo?: boolean;
  colonna?: boolean;
}) {
  return (
    <article
      className={`flex min-w-0 flex-col ${nudo ? "" : "border border-ink border-t-4 border-t-segnale bg-surface"}`}
    >
      {e.foto ? (
        <span
          className={`relative block overflow-hidden bg-surface2 ${colonna ? "aspect-[16/8]" : "min-h-[260px] flex-1"}`}
        >
          <Image
            src={e.foto}
            alt=""
            fill
            sizes={colonna ? "(min-width: 1024px) 380px, 100vw" : "(min-width: 1440px) 672px, (min-width: 768px) 48vw, 100vw"}
            className="object-cover grayscale"
          />
        </span>
      ) : null}
      <div className="flex flex-col gap-2.5 px-[22px] pt-5 pb-[22px]">
        <p className={`m-0 flex items-center gap-2 ${ETICHETTA_ACCESA}`}>
          <Icona nome="editoriale" className="size-5 text-ink" />
          L&rsquo;editoriale della settimana
        </p>
        <h2
          className={`m-0 font-serif leading-[1.05] font-normal italic ${colonna ? "text-[28px]" : "text-[30px] sm:text-[34px]"}`}
        >
          <Link href={e.href} className={TITOLO_LINK}>
            {e.titolo}
          </Link>
        </h2>
        <p className={`m-0 font-serif leading-[1.5] text-ink ${colonna ? "text-[16px]" : "text-[18px]"}`}>{e.sommario}</p>
        <p className={`m-0 mt-1 border-t border-rule pt-2.5 ${DATI_MONO}`}>
          {e.firma} · <time dateTime={e.iso}>{e.data}</time>
        </p>
      </div>
    </article>
  );
}
